import React, { useState, useEffect, forwardRef, useImperativeHandle, useRef } from "react";
import "./style.css";
import { SIDEBAR_DEFAULT_WIDTH, SIDEBAR_MAX_WIDTH, SIDEBAR_MIN_WIDTH, SIDEBAR_MOBILE_WIDTH } from "./constants";

interface SidebarProps {}

export interface SidebarHandles {
    setShowSidebar: (sidebarContent: JSX.Element | null) => void;
    hideSidebar: () => void;
}

const Sidebar = forwardRef<SidebarHandles, SidebarProps>((props, ref) => {
    const [initialPos, setInitialPos] = useState(0);
    const [initialWidth, setInitialWidth] = useState(0);
    const [isDisplayed, setIsDisplayed] = useState(false);
    const sidebarRef = useRef<HTMLDivElement>(null);
    const [sidebarContent, setSidebarContent] = useState<JSX.Element | null>(null);
    const [sidebarWidth, setSidebarWidth] = useState(0);
    const [isResizing, setIsResizing] = useState(false);
    const isMobileView = window.innerWidth <= SIDEBAR_MOBILE_WIDTH;
    useImperativeHandle(ref, () => ({
        setShowSidebar: (sidebarContent: JSX.Element | null) => {
            setIsDisplayed(true);
            setSidebarContent(sidebarContent);
            const defaultWidth = isMobileView ? window.innerWidth : SIDEBAR_DEFAULT_WIDTH;
            !isDisplayed && setSidebarWidth(defaultWidth);
        },
        hideSidebar: () => {
            setIsDisplayed(false);
            setSidebarContent(null);
            setSidebarWidth(0);
        },
    }));

    const startResizing = (mouseDownEvent: React.MouseEvent) => {
        setIsResizing(true);
        setInitialPos(mouseDownEvent.clientX);
        setInitialWidth(sidebarWidth);
        mouseDownEvent.preventDefault();
    };

    const resize = (mouseMoveEvent: MouseEvent) => {
        if (isResizing) {
            const diff = initialPos - mouseMoveEvent.clientX;
            const newWidth = initialWidth + diff;
            const maxWidth = window.innerWidth <= SIDEBAR_MOBILE_WIDTH ? window.innerWidth : SIDEBAR_MAX_WIDTH;
            if (newWidth < maxWidth && newWidth > SIDEBAR_MIN_WIDTH) {
                setSidebarWidth(newWidth);
            }
        }
    };

    const stopResizing = () => {
        setIsResizing(false);
    };

    useEffect(() => {
        if (isResizing) {
            window.addEventListener("mousemove", resize);
            window.addEventListener("mouseup", stopResizing);
        }

        return () => {
            window.removeEventListener("mousemove", resize);
            window.removeEventListener("mouseup", stopResizing);
        };
    }, [isResizing]);

    return (
        <>
            <div ref={sidebarRef} className={`sidebar ${isDisplayed ? "show" : "hide"}`} style={{ width: `${sidebarWidth}px` }}>
                {!isMobileView && (
                    <div
                        className="resizer"
                        onMouseDown={startResizing}
                        style={{ cursor: "ew-resize", width: "10px", position: "absolute", left: "-10px", top: "0px", bottom: "0px" }}
                    />
                )}
                <button
                    style={{ position: "absolute", top: "10%", right: "20px" }}
                    onClick={() => {
                        setIsDisplayed(false);
                        setSidebarContent(null);
                        setSidebarWidth(0);
                    }}
                >
                    X
                </button>
                {sidebarContent && sidebarContent}
            </div>
        </>
    );
});

export default Sidebar;
